export default __webpack_public_path__ + "./image/2a5688cd35c0bb9d8773450ad752e37b.png";